import React from "react";
import { Link } from "react-router-dom";
import Dropdown from 'react-bootstrap/Dropdown';
import userAvatar from "../assets/img/img1.jpg";
import notification from "../data/Notification";
import { useAuth } from "../contexts/AuthContext";

export default function Header({ onSkin }) {
  const { user, logout } = useAuth();

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <Link
      to=""
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      className="dropdown-link"
    >
      {children}
    </Link>
  ));

  const toggleSidebar = (e) => {
    e.preventDefault();
    let isOffset = document.body.classList.contains("sidebar-offset");
    if (isOffset) {
      document.body.classList.toggle("sidebar-show");
    } else {
      if (window.matchMedia("(max-width: 991px)").matches) {
        document.body.classList.toggle("sidebar-show");
      } else {
        document.body.classList.toggle("sidebar-hide");
      }
    }
  }

  function NotificationList() {
    const notiList = notification.map((item, key) => {
      return (
        <li className="list-group-item" key={key}>
          <div className={(item.status === "online") ? "avatar online" : "avatar"}>{item.avatar}</div>
          <div className="list-group-body">
            <p>{item.text}</p>
            <span>{item.date}</span>
          </div>
        </li>
      )
    });

    return (
      <ul className="list-group">
        {notiList}
      </ul>
    );
  }

  const skinMode = (e) => {
    e.preventDefault();
    e.target.classList.add("active");

    let node = e.target.parentNode.firstChild;
    while (node) {
      if (node !== e.target && node.nodeType === Node.ELEMENT_NODE)
        node.classList.remove("active");
      node = node.nextElementSibling || node.nextSibling;
    }

    let skin = e.target.textContent.toLowerCase();
    let HTMLTag = document.querySelector("html");

    if (skin === "dark") {
      HTMLTag.setAttribute("data-skin", skin);
      localStorage.setItem('skin-mode', skin);
      if (onSkin) onSkin(skin);
    } else {
      HTMLTag.removeAttribute("data-skin");
      localStorage.removeItem('skin-mode');
      if (onSkin) onSkin('');
    }
  };

  const sidebarSkin = (e) => {
    e.preventDefault();
    e.target.classList.add("active");

    let node = e.target.parentNode.firstChild;
    while (node) {
      if (node !== e.target && node.nodeType === Node.ELEMENT_NODE)
        node.classList.remove("active");
      node = node.nextElementSibling || node.nextSibling;
    }

    let skin = e.target.textContent.toLowerCase();
    let HTMLTag = document.querySelector("html");

    HTMLTag.removeAttribute("data-sidebar");

    if (skin !== "default") {
      HTMLTag.setAttribute("data-sidebar", skin);
      localStorage.setItem("sidebar-skin", skin);
    } else {
      localStorage.removeItem("sidebar-skin");
    }
  };

  // Récupérer les initiales du nom pour l'avatar si pas d'image
  const getInitials = () => {
    if (user?.name) {
      return user.name.split(' ').map(n => n[0]).join('').toUpperCase();
    }
    return 'U';
  };

  return (
    <div className="header-main px-3 px-lg-4" style={{background:'#009F60'}}>
      <Link onClick={toggleSidebar} className="menu-link me-3 me-lg-4">
        <i className="ri-menu-2-fill text-white"></i>
      </Link>

      <div className="form-search me-auto  bg-white">
        <input type="text" className="form-control" placeholder="Rechercher..." />
        <i className="ri-search-line"></i>
      </div>

   

      <Dropdown className="dropdown-profile ms-3 ms-xl-4" align="end">
        <Dropdown.Toggle as={CustomToggle}>
          <div className="avatar online">
            <img src={userAvatar} alt="" />
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="mt-10-f">
          <div className="dropdown-menu-body">
            <div className="avatar avatar-xl online mb-3">
              <img src={userAvatar} alt="" />
            </div>
            <h5 className="mb-1 text-dark fw-semibold">{user?.name || 'Utilisateur'}</h5>
            <p className="fs-sm text-secondary">
              {user?.role === 'patient' && 'Assuré CNAMGS'}
              {user?.role === 'doctor' && 'Médecin'}
              {user?.role === 'pharmacist' && 'Pharmacien'}
              {user?.role === 'admin' && 'Administrateur'}
              {!user && 'Invité'}
            </p>

            <nav className="nav">
              <Link to="/pages/profile"><i className="ri-edit-2-line"></i> Modifier profil</Link>
              <Link to="/pages/profile"><i className="ri-profile-line"></i> Voir profil</Link>
            </nav>
            <hr />
            <nav className="nav">
           
              {user ? (
                <Link to="/login" onClick={() => {
                  logout();
                  window.location.href = '/login';
                }}>
                  <i className="ri-logout-box-r-line"></i> Déconnexion
                </Link>
              ) : (
                <Link to="/login"><i className="ri-login-box-line"></i> Connexion</Link>
              )}
            </nav>
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}